import { render, staticRenderFns } from "./EditTitle.vue?vue&type=template&id=47c4812c&scoped=true&"
import script from "./EditTitle.vue?vue&type=script&lang=js&"
export * from "./EditTitle.vue?vue&type=script&lang=js&"
import style0 from "./EditTitle.vue?vue&type=style&index=0&id=47c4812c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4812c",
  null
  
)

export default component.exports